"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSectionsFacade = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var section_1 = require("./section");
/**
 * @alpha
 */
var DashboardLayoutSectionsFacade = /** @class */ (function () {
    function DashboardLayoutSectionsFacade(layoutFacade, sectionFacades) {
        this.layoutFacade = layoutFacade;
        this.sectionFacades = sectionFacades;
    }
    DashboardLayoutSectionsFacade.for = function (layoutFacade, sections) {
        var sectionFacades = sections.map(function (section, index) {
            return section_1.DashboardLayoutSectionFacade.for(layoutFacade, section, index);
        });
        return new DashboardLayoutSectionsFacade(layoutFacade, sectionFacades);
    };
    DashboardLayoutSectionsFacade.prototype.raw = function () {
        return this.sectionFacades.map(function (s) { return s.raw(); });
    };
    DashboardLayoutSectionsFacade.prototype.all = function () {
        return this.sectionFacades;
    };
    DashboardLayoutSectionsFacade.prototype.section = function (index) {
        return this.sectionFacades[index];
    };
    DashboardLayoutSectionsFacade.prototype.flatMap = function (callback) {
        return flatMap_1.default(this.sectionFacades, callback);
    };
    DashboardLayoutSectionsFacade.prototype.count = function () {
        return this.sectionFacades.length;
    };
    DashboardLayoutSectionsFacade.prototype.map = function (callback) {
        return this.sectionFacades.map(callback);
    };
    DashboardLayoutSectionsFacade.prototype.reduce = function (callback, initialValue) {
        return this.sectionFacades.reduce(callback, initialValue);
    };
    DashboardLayoutSectionsFacade.prototype.every = function (pred) {
        return this.sectionFacades.every(pred);
    };
    DashboardLayoutSectionsFacade.prototype.some = function (pred) {
        return this.sectionFacades.some(pred);
    };
    DashboardLayoutSectionsFacade.prototype.find = function (pred) {
        return this.sectionFacades.find(pred);
    };
    DashboardLayoutSectionsFacade.prototype.filter = function (pred) {
        return this.sectionFacades.filter(pred);
    };
    return DashboardLayoutSectionsFacade;
}());
exports.DashboardLayoutSectionsFacade = DashboardLayoutSectionsFacade;
//# sourceMappingURL=sections.js.map